import { Timestamp } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { validate as validateUUID } from 'uuid';


import { SubTitleRendererParams } from '../../subTitleRenderers';

export function teamConversationSubTitleRenderer(
  params: SubTitleRendererParams,
) {
  const { metaConversation } = params;
  const { conversation } = metaConversation;
  const { last_message_created_at: lastMessageCreatedAt } = conversation;

  const separator = ' · ';
  const CSID = metaConversation.conversation.id;
  const queueName = validateUUID(conversation.queue?.name ?? '')
    ? null // There is a bug in backend where they return uuid instead of name. We don't want to show uuid.
    : conversation.queue?.name;

  return (
    <>
      {CSID && <span>{`#${CSID}`}</span>}

      {lastMessageCreatedAt && (
        <>
          {separator}
          <span
            onClick={() =>
              ampli.conversationsTimestampClicked({
                context: 'created',
              })
            }
          >
            <Timestamp relative time={lastMessageCreatedAt} />
          </span>
        </>
      )}

      {queueName && (
        <>
          <span>
            {separator}
            {queueName}
          </span>
        </>
      )}
    </>
  );
}
